import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./lib/LanguageContext";
import { AuthProvider } from "./lib/AuthContext";
import { CurrencyProvider } from "./lib/CurrencyContext";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Rooms from "./pages/Rooms";
import Facilities from "./pages/Facilities";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import BookingForm from "./pages/BookingForm";
import FAQ from "./pages/FAQ";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Admin from "./pages/Admin";
import Login from "./pages/Login";

function App() {
    return (
        <div className="App">
            <LanguageProvider>
                <CurrencyProvider>
                    <AuthProvider>
                        <BrowserRouter>
                            <Routes>
                                <Route element={<Layout />}>
                                    <Route path="/" element={<Home />} />
                                    <Route path="/rooms" element={<Rooms />} />
                                    <Route path="/facilities" element={<Facilities />} />
                                    <Route path="/gallery" element={<Gallery />} />
                                    <Route path="/contact" element={<Contact />} />
                                    <Route path="/book" element={<BookingForm />} />
                                    <Route path="/faq" element={<FAQ />} />
                                    <Route path="/blog" element={<Blog />} />
                                    <Route path="/blog/:slug" element={<BlogPost />} />
                                </Route>
                                <Route path="/admin/login" element={<Login />} />
                                <Route path="/admin" element={<Admin />} />
                            </Routes>
                        </BrowserRouter>
                        <Toaster position="top-right" richColors />
                    </AuthProvider>
                </CurrencyProvider>
            </LanguageProvider>
        </div>
    );
}

export default App;
